'use client'
import {
  SEO_QUERY
} from "./chunk-W3K3QG4J.mjs";
import {
  FOOTER_QUERY
} from "./chunk-W6OP5ODI.mjs";
import {
  HEADER_QUERY
} from "./chunk-WQ643R7Q.mjs";
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async
} from "./chunk-BTG5EALA.mjs";

// src/api/config/config.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var getWebsiteConfig = (_0) => __async(void 0, [_0], function* ({ lang = "en", slug }) {
  var _a, _b, _c;
  try {
    const res = yield gqlClient.request(
      gql`
        query getConfig($lang: String, $slug: String) {
          webConfigCollection(where: { slug: $slug }, limit: 1, locale: $lang) {
            items {
              title
              logo {${IMAGE_QUERY}}
              miniLogo {${IMAGE_QUERY}}
              seo {${SEO_QUERY}}
              header {${HEADER_QUERY}}
              footer {${FOOTER_QUERY}}
              socialLinks {
                title
                iconLinksCollection {
                  items {${LINK_QUERY}}
                }
              }
              manifestUrl
              favicon {${IMAGE_QUERY}} 
            }
          }
        }
      `,
      { lang: getContentfulSafeLocale(lang), slug }
    );
    if (!((_a = res == null ? void 0 : res.webConfigCollection) == null ? void 0 : _a.items.length)) {
      throw new Error("No web config found");
    }
    return (_c = (_b = res == null ? void 0 : res.webConfigCollection) == null ? void 0 : _b.items) == null ? void 0 : _c[0];
  } catch (error) {
    throw new Exception({ error });
  }
});
var useWebsiteConfig = (props) => {
  return useQuery({
    queryKey: ["websiteConfig", props],
    queryFn: () => getWebsiteConfig(props)
  });
};

export {
  useWebsiteConfig
};
//# sourceMappingURL=chunk-RSZXEKNC.mjs.map